import { END_POINTS } from "../helpers";
import { CommonBody, Partner } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const vehiclesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllVehicles: builder.query<
      CommonResponse & { data: Partner },
      { page: number; search: string; isSubscription: boolean }
    >({
      query: ({ page, search, isSubscription }) => ({
        url: `${END_POINTS.vehicles}?page=${page}&search=${search}&isSubscription=${isSubscription}`,
        method: "GET",
      }),
    }),
    addVehicle: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addVehicles,
        method: "POST",
        body,
      }),
    }),
    updateVechile: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateVechile}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    getVechileById: builder.query<
      CommonResponse & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.vehicles}/${id}`,
        method: "GET",
      }),
    }),
    deleteVehicle: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.vehicles}/${id}`,
        method: "DELETE",
      }),
    }),
    getAllCits: builder.query<CommonResponse & { data: any }, {}>({
      query: () => ({
        url: `${END_POINTS.cities}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetAllVehiclesQuery,
  useAddVehicleMutation,
  useUpdateVechileMutation,
  useLazyGetVechileByIdQuery,
  useLazyDeleteVehicleQuery,
  useLazyGetAllCitsQuery,
} = vehiclesApi;
